import { useEffect, useRef } from "react";
import type { CameraKitOrganization } from "../../../gql-generated/types";
import { useOrganizations, useSwitchOrganization } from "../../organizations/hooks";
import { useSelectedOrganizationContainer } from "../../../shared/hooks";
import { useOrganizationService } from "../../organizations/hooks/useOrganizationsService";

export const useOrganizationSwitcher = (orgId: string | undefined) => {
    const { selectedOrganizationId, switchOrganization } = useSwitchOrganization();
    const { organizations, loading } = useOrganizations();
    const organizationService = useOrganizationService();
    const isFirstMount = useRef(true);

    const { orgId: selectedOrganizationContainerId } = useSelectedOrganizationContainer();

    useEffect(() => {
        if (loading) {
            return;
        }

        const organizationId = selectedOrganizationContainerId ?? orgId;

        if (isFirstMount.current) {
            isFirstMount.current = false;
            organizationService.selectIfValidOrganization(organizationId ?? "");
            return;
        } else if (selectedOrganizationId == null) {
            const selectedOrg = organizations?.find((org) => org?.id === organizationId) ?? organizations![0];
            if (selectedOrg !== null && selectedOrg !== undefined) {
                switchOrganization(selectedOrg as Readonly<CameraKitOrganization>);
            }
        }

        if (organizationId && selectedOrganizationId !== organizationId) {
            const selectedOrg = organizations?.find((org) => org?.id === organizationId) ?? organizations![0];
            switchOrganization(selectedOrg);
        }
    }, [
        orgId,
        loading,
        organizationService,
        organizations,
        selectedOrganizationContainerId,
        selectedOrganizationId,
        switchOrganization,
    ]);

    return { selectedOrganizationId, loading };
};
